(function (global) {
  'use strict';
  if (global.QtiquesEvents) return;
  function parseDate(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    var parts = value.split('-').map(Number);
    var date = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
    return date.toISOString().slice(0, 10) === value ? date : null;
  }
  function today(now) {
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now || new Date());
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    return values.year + '-' + values.month + '-' + values.day;
  }
  function select(raw, date, flyersOnly, limit) {
    if (!Array.isArray(raw) || raw.length > 25000 || !parseDate(date)) return null;
    var seen = new Set();
    var records = [];
    raw.forEach(function (record) {
      if (!record || typeof record.id !== 'string' || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(record.id) || seen.has(record.id)) return;
      var start = parseDate(record.start), end = parseDate(record.end || record.start);
      if (!start || !end || end < start || (flyersOnly && (record.end || record.start) < date) || typeof record.title !== 'string' || !record.title.trim() || (flyersOnly ? ['upcoming', 'cancelled'] : ['upcoming', 'cancelled', 'past']).indexOf(record.status) < 0) return;
      seen.add(record.id);
      if (flyersOnly && (record.status !== 'upcoming' || record.flyer !== true)) return;
      records.push({ id: record.id, title: record.title.trim(), status: record.status, start: start, end: end });
    });
    records.sort(function (a, b) {
      var aCurrent = a.start <= parseDate(date), bCurrent = b.start <= parseDate(date);
      return Number(bCurrent) - Number(aCurrent) || a.start - b.start || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
    });
    return records.slice(0, limit || 24);
  }
  var allRecords = null;
  function read(root, flyersOnly, limit) {
    var source = root.querySelector('[data-qtiques-event-projection]');
    try { return select(allRecords || JSON.parse(source.textContent), today(), flyersOnly, limit); } catch (_) { return null; }
  }
  function reconcile(root, records) {
    var cards = root.querySelectorAll('[data-event-id]');
    var selected = new Map((records || []).map(function (event, index) { return [event.id, index]; }));
    Array.prototype.forEach.call(cards, function (card) { card.hidden = !selected.has(card.getAttribute('data-event-id')); });
    (records || []).forEach(function (event) {
      Array.prototype.forEach.call(cards, function (card) {
        if (card.getAttribute('data-event-id') === event.id) {
          card.parentNode.appendChild(card);
          var label = card.querySelector('[data-event-status]');
          if (label) label.textContent = event.status === 'cancelled' ? 'Cancelled' : event.start <= parseDate(today()) ? 'Current' : 'Upcoming';
        }
      });
    });
    var empty = root.querySelector('[data-events-empty]');
    if (empty) empty.hidden = Boolean(records && records.length);
  }
  function scan(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-qtiques-home-flyers]')) roots.push(scope);
    Array.prototype.push.apply(roots, scope.querySelectorAll('[data-qtiques-home-flyers]'));
    roots.forEach(function (root) {
      var records = read(root, true, Number(root.getAttribute('data-flyer-limit')));
      if (records) {
        records.forEach(function (event) { ensureHomeCard(root, event.id); });
        reconcile(root, records);
        var leading = root.querySelector('[data-home-leading-flyer]');
        var trailing = root.querySelector('[data-home-trailing-flyers]');
        var firstCards = root.querySelector('[data-home-leading-cards]');
        var nextCards = root.querySelector('[data-home-trailing-cards]');
        if (leading && trailing && firstCards && nextCards) {
          // Move existing cards, never clone artwork or event identities.
          Array.prototype.forEach.call(root.querySelectorAll('[data-event-id]'), function (card) {
            var first = records.length && card.getAttribute('data-event-id') === records[0].id;
            (first ? firstCards : nextCards).appendChild(card);
          });
          leading.hidden = records.length === 0;
          trailing.hidden = records.length < 2;
          trailing.setAttribute('data-flyer-count', String(Math.max(records.length - 1, 0)));
        }
      }
    });
  }
  function entry(id) { return allRecords && allRecords.find(function (r) { return r.id === id; }); }
  function node(tag, text, cls) { var el = document.createElement(tag); if (text) el.textContent = text; if (cls) el.className = cls; return el; }
  function imageFor(r, cls) { if (!r.image) return null; try { var url = new URL(r.image, location.origin); if (url.protocol !== 'https:' || (url.hostname !== location.hostname && url.hostname !== 'cdn.shopify.com')) return null; var el = node('img', '', cls); el.src = url.href; el.alt = r.alt || r.title; el.loading = 'lazy'; el.width = r.width || 900; el.height = r.height || 1200; return el; } catch (_) { return null; } }
  function ensureHomeCard(root, id) { if (!allRecords || root.querySelector('[data-event-id="' + id + '"]')) return; var r = entry(id), parent = root.querySelector('[data-home-leading-cards]') || root.querySelector('[data-home-trailing-cards]'); if (!r || !parent) return; var card = node('article', '', 'qtiques-discovery__card qtiques-discovery__event-card'); card.setAttribute('data-event-id', id); var image = imageFor(r, 'qtiques-discovery__event-image'); if (image) card.appendChild(image); var copy = node('div', '', 'qtiques-discovery__card-copy'); copy.appendChild(node('p', r.start + (r.end && r.end !== r.start ? '–' + r.end : ''), 'qtiques-discovery__meta')); copy.appendChild(node('h4', r.title)); if (r.summary) copy.appendChild(node('p', r.summary)); card.appendChild(copy); parent.appendChild(card); }
  function ensureDetail(root, id) {
    var r = entry(id), parent = root.querySelector('.qtiques-events-list__items');
    if (!r || !parent) return null;
    var card = node('article', '', 'qtiques-events-list__item');
    if (r.status === 'cancelled') card.className += ' qtiques-events-list__item--cancelled';
    card.id = id; card.tabIndex = -1;
    card.setAttribute('data-event-detail', ''); card.setAttribute('data-event-id', id);
    card.setAttribute('data-event-start', r.start); card.setAttribute('data-event-end', r.end || r.start);
    card.hidden = (r.end || r.start) < today();
    var copy = node('div', '', 'qtiques-events-list__copy');
    var status = node('p', r.status === 'cancelled' ? 'Cancelled' : card.hidden ? 'Past event' : 'Upcoming', 'qtiques-events-list__status');
    status.setAttribute('data-event-status', ''); copy.appendChild(status);
    copy.appendChild(node('p', r.start + (r.end && r.end !== r.start ? '–' + r.end : ''), 'qtiques-events-list__date'));
    copy.appendChild(node('h3', r.title));
    if (r.summary) copy.appendChild(node('p', r.summary));
    card.appendChild(copy);
    var image = imageFor(r, 'qtiques-events-list__image');
    if (image) {
      var media = node('div', '', 'qtiques-events-list__media');
      var link = node('a', '', 'qtiques-events-list__flyer-link');
      var full = new URL(image.src); full.searchParams.set('width', '2400');
      link.href = full.href; link.target = '_blank'; link.rel = 'noopener';
      link.setAttribute('aria-label', 'Open full-size flyer for ' + r.title + ' (opens in a new tab)');
      link.appendChild(image); link.appendChild(node('span', 'Open full-size flyer ↗'));
      media.appendChild(link); card.appendChild(media);
    }
    parent.appendChild(card); return card;
  }
  async function loadIndex() { var rows = [], seen = new Set(); for (var page = 1; page <= 100; page++) { var response = await fetch('/pages/events-sales?view=flyer-index&page=' + page, { credentials: 'omit', redirect: 'error' }); if (!response.ok) throw Error('Calendar index unavailable'); var text = await response.text(); if (text.length > 2000000) throw Error('Calendar page too large'); var data = JSON.parse(text); if (!Array.isArray(data.entries) || data.entries.length > 250) throw Error('Invalid calendar index'); data.entries.forEach(function (r) { if (r && typeof r.id === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(r.id) && !seen.has(r.id)) { seen.add(r.id); rows.push(r); } }); if (!data.nextPage) { allRecords = rows; scan(document); document.dispatchEvent(new Event('qtiques:records-ready')); return; } if (data.nextPage !== page + 1) throw Error('Invalid calendar pagination'); } throw Error('Calendar pagination exceeds platform bound'); }
  global.QtiquesEvents = { parseDate: parseDate, today: today, select: select, read: read, reconcile: reconcile, ensureDetail: ensureDetail };
  scan(document);
  if (typeof fetch === 'function' && typeof document.createElement === 'function') loadIndex().catch(function () { document.dispatchEvent(new Event('qtiques:index-unavailable')); });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
}(window));
